import { SelectInputData } from "@src/components/deprecated/SelectInputField/SelectInputField";
import { loadPropertyMembersAsUsers } from "@src/components/deprecated/UserSelectPopup/UserSelectPopUp";
import { t } from "i18next";
import { UserData } from "to-be-removed/LocalData/User/UserData";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { LocalData } from "../../LocalData";
import { FirebaseDataSelectField, FirebaseDataSelectFieldOption } from "../Generic/FirebaseDataSelectField";

export class FirebaseDataUserField<FirebaseDataType extends DataObjectType> extends FirebaseDataSelectField<UserData, FirebaseDataType> {
  override convertValueToSelectInput(value: UserData): SelectInputData {
    return new SelectInputData(value.id, value.name);
  }
  getValueForKey(key: string): UserData | undefined {
    if (key === "@me") return LocalData.currentUser;
    return LocalData.users.addData(key);
  }
  getOptions(): FirebaseDataSelectFieldOption[] {
    const users = LocalData.users.documents
      .filter((user) => user.loaded && !user.deleted)
      .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      .map((user) => {
        return {
          key: user.id,
          label: user.name,
        };
      });

    // Insert @me at top
    users.unshift({
      key: "@me",
      label: "@" + t("main.myself"),
    });

    return users;
  }
  override encode = (value: UserData) => value.id;

  getColor(value: UserData): string | undefined {
    return value && value.userColors ? "rgb(" + value.userColors[0] + "," + value.userColors[1] + "," + value.userColors[2] + ")" : undefined;
  }

  getReadableStringRepresentation(value: UserData): string {
    return value.name;
  }
  loadAllDatas(): Promise<void> {
    return loadPropertyMembersAsUsers().then(() => {});
  }
  override isValueValid = (value: any): boolean => {
    return value instanceof UserData;
  };
}

